import React, { useCallback } from 'react';
import { AddressInfoInput } from '~/components';
import type { StepComponentProps } from '~/components/StepsForm';
import type { ThirdStepFormData } from '~/@types/MarisaTakesCare/form';
import { useTakesCareFormStore } from '~/stores/marisaTakesCareForm';

const ThirdStep: React.FC<StepComponentProps> = ({ onContinue }) => {
  const {
    functions: { setThirdStepData },
  } = useTakesCareFormStore();

  const onSubmit = useCallback(
    (data: ThirdStepFormData) => {
      setThirdStepData(data);
      onContinue?.();
    },
    [onContinue, setThirdStepData]
  );

  return (
    <AddressInfoInput insuranceType="marisa-cuida" onValidate={onSubmit} />
  );
};

export default ThirdStep;
